import { createTheme } from "@material-ui/core/styles";
import "typeface-montserrat";
import SfUiDisplayBlack from "./fonts/SF-UI-Display-Black.woff";
import SfUiDisplayBold from "./fonts/SF-UI-Display-Bold.woff";
import SfUiDisplayRegular from "./fonts/SF-UI-Display-Regular.woff";

const sfUiDisplayBlack = {
  fontFamily: 'SF UI Display Black',
  fontStyle: 'black',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
    local('SF UI Display Black'),
    url(${SfUiDisplayBlack}) format('woff')
  `,
  unicodeRange:
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};

const sfUiDisplayBold = {
  fontFamily: 'SF UI Display Bold',
  fontStyle: 'bold',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
    local('SF UI Display Bold'),
    url(${SfUiDisplayBold}) format('woff')
  `,
  unicodeRange:
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};

const sfUiDisplayRegular = {
  fontFamily: 'SF UI Display Regular',
  fontStyle: 'regular',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
    local('SF UI Display Regular'),
    url(${SfUiDisplayRegular}) format('woff')
  `,
  unicodeRange:
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};

const Theme = createTheme({
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [sfUiDisplayRegular, sfUiDisplayBold, sfUiDisplayBlack],
      },
    },
  },
  palette: {
    primary: { main: "#fff" },
    secondary: { main: "#55565A" },
    background: "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)"
  },
  typography: {
    fontFamily: ["Montserrat", "SF UI Display Regular", "SF UI Display Black", "SF UI Display Bold"].join(","),
    fontWeightBold: 600,
    h5: {
      fontFamily: '"SF UI Display Black"',
    },
    h6: {
      fontFamily: '"SF UI Display Bold"',
    }
  },
  background: "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
  kooee: {
    buttons: {},
    textFields: {},
    input: {},
    backgrounds: {
      default: "#EDF1F4",
      primary: "#fff",
      secondary: "#fff",
      other: "#FF6666"
    },
    titles: {
      primary: "#55565A"
    },
    slider: {
      background: "#FF6666",
      rail: "#d8d8d8",
      mark: "#8A9095",
      rootColor: "#D3DBE2"
    },
    itemsTab: {
      // primary: "#FFCC00",
      primary: "#5060b0",
      default: "#A6B1C1",
      secondary: "#0BAB24",
      other: "#14D132"
    },
    chips: {},
    text: {
      primary: "#4A4F5B"
    },
    checkbox: {},
    border: {},
    skeleton: {}
  }
});

export default Theme;
